import { FC } from 'react';

type Props = {
	value: string;
};

const DurationTimer: FC<Props> = ({ value }) => {
	return <span>{value}</span>;
};

export default DurationTimer;
